import React, { useContext, useState, useEffect } from 'react';
import classnames from 'classnames';
import AC_GRID from '../../AutocodeTypes';
import { AC_ROOT_NODE_ID } from '../../AutocodeConstants';
import ACDictionaryContext from '../../ACContext/ACDictionaryContext';
import { useACSelectionBoxContext } from '../../ACContext/ACSelectionBoxContext';
import AutocodeSelectionAction from '../../AutocodeSelectionBox/AutocodeSelectionActions';
import AutocodeCheckBox from '../../ACShared/AutocodeCheckBox';
import GenericButton from '../../../common/GenericButton';
import ACTemplateRow from './ACTemplateRow';
import AutocodeCustomDragLayer from '../../AutocodeCustomDragLayer';
import { getDatapointsForSingleList } from '../../../../util/AutocodeDragAndDropUtils';

const ACTemplate1dot1 = () => {
  const { selectedNodeAnswers, disableAddButton } = useContext(
    ACDictionaryContext
  );
  const acSelContext = useACSelectionBoxContext();
  const { insertLeafNode } = AutocodeSelectionAction(
    acSelContext.state,
    acSelContext.dispatch
  );

  const [addButtonDisabled, setaddButtonDisabled] = useState(true);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    setaddButtonDisabled(!selectedItems.some(i => i.checked));
    setAllSelected(selectedItems.every(i => i.checked));
  }, [selectedItems]);

  useEffect(() => {
    setSelectedItems(
      selectedNodeAnswers.root.children.map(a => ({ ...a, checked: false }))
    );
  }, [selectedNodeAnswers]);

  const getSelectedEntries = () => selectedItems.filter(item => item.checked);

  const selectAll = isChecked => {
    setSelectedItems(selectedItems.map(a => ({ ...a, checked: isChecked })));
    setAllSelected(isChecked);
  };

  const setItemList = (selectedItems, isChecked, item) => {
    const index = selectedItems.findIndex(a => a.node === item.node);
    setSelectedItems([
      ...selectedItems.slice(0, index),
      { ...selectedItems[index], checked: isChecked },
      ...selectedItems.slice(index + 1),
    ]);
  };

  const selectItem = (isChecked, item, event) => {
    let checkedItems = [];
    checkedItems = selectedItems.filter(i => i.checked);

    // check single item if shift key is not pressed or item is being unchecked
    // ...or shift key is pressed and no other items checked
    if (
      !event ||
      !event.nativeEvent.shiftKey ||
      (event && event.nativeEvent.shiftKey && checkedItems.length === 0) ||
      !isChecked
    ) {
      setItemList(selectedItems, isChecked, item);
      return;
    }
    // find range of items between last checked item and item being checked

    let lastCheckedItem = [];
    lastCheckedItem = checkedItems[checkedItems.length - 1];
    const startIndex = selectedItems.indexOf(lastCheckedItem);
    const endIndex = selectedItems.indexOf(item);
    let fromIndex = 0;
    let toIndex = 0;
    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
      fromIndex = startIndex;
      toIndex = endIndex;
    } else {
      fromIndex = endIndex;
      toIndex = startIndex;
    }

    // check all those items in range
    let itemsInRange = [];
    itemsInRange = selectedItems.slice(fromIndex, toIndex + 1);
    setSelectedItems([
      ...selectedItems.slice(0, fromIndex),
      ...itemsInRange.map(a => ({ ...a, checked: isChecked })),
      ...selectedItems.slice(toIndex + 1),
    ]);
  };

  const addToSelectionBox = () => {
    // Setting final datapoints data from AutocodeDragAndDropUtils to add data to selection box
    const datapoints = getDatapointsForSingleList(
      selectedItems,
      selectedNodeAnswers
    );

    // insert into selection box
    insertLeafNode(datapoints, AC_ROOT_NODE_ID, -1);

    // uncheck items after adding to selection box
    setSelectedItems(selectedItems.map(a => ({ ...a, checked: false })));
    setAllSelected(false);
  };

  const resetSelectedRows = () => {
    setAllSelected(false);
    setSelectedItems(selectedItems.map(a => ({ ...a, checked: false })));
  };

  return (
    <div>
      <div className="ac-dictionary-container">
        <div
          className={classnames('ac-dictionary-row', {
            'ac-dictionary-row-checked': allSelected,
          })}
        >
          <div className="ac-dictionary-row-checkbox">
            <AutocodeCheckBox
              onChange={selectAll}
              id="all-items"
              isChecked={allSelected}
              fill="#94A2B7"
              stroke="#94A2B7"
              allCheck
              label="All"
            />
          </div>
        </div>
        <div className="ac-dictionary-rows-list">
          <AutocodeCustomDragLayer
            items={getSelectedEntries()}
            type={AC_GRID.AC_TEMPLATE_SINGLE_LIST}
          />
          {selectedItems.map(item => (
            <ACTemplateRow
              ACTemplateType={AC_GRID.AC_TEMPLATE_SINGLE_LIST}
              key={item.node}
              onChange={selectItem}
              id={`item-${item.node}`}
              isChecked={item.checked}
              fill={item.checked ? '#94A2B7' : '#94A2B7'}
              stroke={item.checked ? '#94A2B7' : '#94A2B7'}
              data={item}
              label={item.shortText}
              selectedItems={selectedItems}
              selectedNodeAnswers={selectedNodeAnswers}
              isDragable={!addButtonDisabled && !disableAddButton}
              resetSelectedRows={resetSelectedRows}
            />
          ))}
        </div>
      </div>
      <div
        style={{
          borderTop: '1px solid #e0e0e0',
        }}
      >
        <div style={{ marginTop: '15px' }}>
          <GenericButton
            name="Add"
            btnStyle="ac-dictionary__addbutton"
            btnDisabled={addButtonDisabled || disableAddButton}
            onBtnClick={addToSelectionBox}
          />
        </div>
      </div>
    </div>
  );
};

export default ACTemplate1dot1;
